module.exports = __webpack_public_path__ + "static/img/cont47 (2).743db0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont47 (2).jpg
// module id = zyLC
// module chunks = 0